import styled from 'styled-components';
import {FOOT_TRAFFIC_LIMIT_AREA, FOOT_TRAFFIC_LIMIT_RADIUS} from '@/map/constants';
import {AreaOverlayType} from '@/map/enums';
import {distanceToString} from '@/map/utils';
import {Section} from '@/styled-components';
import {BoxTitle, EmptyBox} from '../StyledComponents';

interface IProps {
  type: AreaOverlayType;
}

export const FootTrafficDisableBox = ({type}: IProps) => {
  return (
    <Root>
      <BoxTitle>유동인구</BoxTitle>
      <Section spacing={2}>
        {type === AreaOverlayType.CIRCLE ? (
          <span>
            반경 {distanceToString(FOOT_TRAFFIC_LIMIT_RADIUS)}까지 제공하는
            기능입니다.
            <br />
            분석 반경을 좁혀주세요.
          </span>
        ) : type === AreaOverlayType.POLYGON ? (
          <span>
            선택면적{' '}
            {distanceToString(FOOT_TRAFFIC_LIMIT_AREA, {useAreaUnit: true})}
            까지 제공하는 기능입니다.
            <br />
            분석 면적을 좁혀주세요.
          </span>
        ) : (
          <span>
            반경 및 다각형 분석에서
            <br />
            제공하는 기능입니다.
          </span>
        )}
      </Section>
    </Root>
  );
};

const Root = styled(EmptyBox)`
  display: block;
  padding: 4px;
  margin-top: 8px;
`;
